// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YCJ7","buttons":"Footer_buttons__12Io7"};